module.exports = __webpack_public_path__ + "img/icon_acc_notify.1e94d198.svg";